import { render, staticRenderFns } from "./ManageUrbanismRegulationsModal.vue?vue&type=template&id=70454d89&"
import script from "./ManageUrbanismRegulationsModal.vue?vue&type=script&lang=js&"
export * from "./ManageUrbanismRegulationsModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageUrbanismRegulationsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports